export const PROJECT_LEAVE_LIST = "PROJECT_LEAVE_LIST";
export const PROJECT_LEAVE_BY_EMPLOYEE_LIST = "PROJECT_LEAVE_BY_EMPLOYEE_LIST";
export const PROJECT_LEAVE_BY_EMPLOYEE_INFO = "PROJECT_LEAVE_BY_EMPLOYEE_INFO";
export const HISTORY_PROJECT_LEAVE_LIST = "HISTORY_PROJECT_LEAVE_LIST";
